module.exports = __webpack_public_path__ + "static/media/Project1_Demo8.d3ae1f9b.png";